import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [운영 설정 > 수집서버 설정] 수집서버 그룹 리스트를 조회한다.
   * @author najongdang
   * @return {[type]}        [description]
   */
  getAgentGroupList() {
    return axios.get(`${baseUrl}/settings/common/agent/get-agent-group-list.do`);
  },

  /**
   * [운영 설정 > 수집서버 설정] 수집서버 추가에서 수집 서버 그룹 아이디 중복 체크
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  checkAgentManagerGroupIdValidation(params) {
    return axios.post(`${baseUrl}/settings/common/agent/check-agent-manager-group-id-validation.do`, params);
  },

  /**
   * [운영 설정 > 수집서버 설정] 수집서버 그룹을 추가한다
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertAgentGroup(params) {
    return axios.post(`${baseUrl}/settings/common/agent/insert-agent-group.do`, params);
  },

  /**
   * [운영 설정 > 수집서버 설정] 수집서버 그룹을 수정한다
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateAgentGroup(params) {
    return axios.post(`${baseUrl}/settings/common/agent/update-agent-group.do`, params);
  },

  /**
   * [운영 설정 > 수집서버 설정] 수집서버 그룹을 삭제한다
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteAgentGroup(params) {
    return axios.post(`${baseUrl}/settings/common/agent/delete-agent-group.do`, params);
  },

  /**
   * [운영 설정 > 수집서버 설정] 수집서버 그룹을 삭제한다
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getObjectOfAgentGroup(params) {
    return axios.post(`${baseUrl}/settings/common/agent/get-object-of-agent-group.do`, params);
  },

  /**
   * [운영 설정 > 수집서버 설정] agent_manager_group_id에 따른 obj 목록을 수정한다.
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateObjectOfAgentGroup(params) {
    return axios.post(`${baseUrl}/settings/common/agent/update-object-of-agent-group.do`, params);
  },

  /**
   * [운영 설정 > 수집서버 목록] agent_manager_group_id에 따른 agent_mgr 목록을 조회한다.
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getAgentOfAgentGroup(params) {
    return axios.post(`${baseUrl}/settings/common/agent/get-agent-of-agent-group.do`, params);
  },

  /**
   * [운영 설정 > 수집서버 목록] agent_manager_Id 사용 validation 체크
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  checkAgentManagerIdValidation(params) {
    return axios.post(`${baseUrl}/settings/common/agent/check-agent-manager-id-validation.do`, params);
  },

  /**
   * [운영 설정 > 수집서버 목록] agent_manager를 추가한다.
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertAgentManager(params) {
    return axios.post(`${baseUrl}/settings/common/agent/insert-agent-manager.do`, params);
  },

  /**
   * [운영 설정 > 수집서버 목록] agent_manager를 수정한다.
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateAgentManager(params) {
    return axios.post(`${baseUrl}/settings/common/agent/update-agent-manager.do`, params);
  },

  /**
   * [운영 설정 > 수집서버 목록] agent_manager를 삭제한다.
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteAgentManager(params) {
    return axios.post(`${baseUrl}/settings/common/agent/delete-agent-manager.do`, params);
  },

  /**
   * [운영 설정 > 수집서버 목록] agent_manager의 obj를 가지고 온다.
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getObjectOfAgentManager(params) {
    return axios.post(`${baseUrl}/settings/common/agent/get-object-of-agent-manager.do`, params);
  },

  /**
   * [운영 설정 > 수집서버 목록] agent_manager의 obj를 가지고 온다.
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateObjectOfAgentManager(params) {
    return axios.post(`${baseUrl}/settings/common/agent/update-object-of-agent-manager.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/agent-settings.js